export const RECAPTCHA_TOKEN_FIELD = 'g-recaptcha-response';
